import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { clsx } from "clsx"

import { onClickAddFriend } from "../utils/hook"

import Text from "./text"
import ButtonFill from "./button-fill"

import Space from "../components/space"

type Props = {
  mainTextLen: number
  nagativeMarginTop: boolean
  utmSource: string
  utmMedium: string
  utmCampaign: string
  utmContent: string
}
export default function ReadMore(props: Props) {
  const {
    mainTextLen,
    nagativeMarginTop,
    utmSource,
    utmMedium,
    utmCampaign,
    utmContent,
  } = props

  return (
    <div className={clsx(
      "relative",
      {
        "-mt-[84px] lg:-mt-[76px]": nagativeMarginTop,
      }
    )}>
      {nagativeMarginTop && (
        <>
          <div className="bg-readmore">
            <div className="h-[46px] lg:h-[40px]" />
          </div>
          <div className="bg-white">
            <div className="h-[38px] lg:h-[36px]" />
          </div>
        </>
      )}

      <Space sizeY="6" lgSizeY="12" />

      <div className="flex flex-row items-center gap-4">
        <div className="w-full border-b-[1px] border-dashed border-[#BAC9CA]" />
        <div className="shrink-0 text-[#2D2E31] font-bold text-[13px] lg:text-[16px]">
          続きを読むには
        </div>
        <div className="w-full border-b-[1px] border-dashed border-[#BAC9CA]" />
      </div>

      <div className="py-[30px] text-center">
        <div className="text-[#2D2E31] text-[11px] lg:text-[14px]">
          <StaticImage
            src="../images/readmore/lock.png"
            alt="lock"
            placeholder="none"
            width={16}
            className="mr-1"
          />
          記事の続きはペアケアプレミアムに登録すると見られます。
        </div>
        <Space sizeY="3" lgSizeY="4" />
        <div className="text-[#707979] text-[11px] lg:text-[14px]">
          残り{mainTextLen}文字
        </div>
        <Space sizeY="3" lgSizeY="4" />
        <div className="">
          <ButtonFill
            onClick={() => {
              onClickAddFriend({ utmSource, utmMedium, utmCampaign, utmContent: "readmore" })
            }}
            classes="py-3 px-[60px]"
            roundedSize="full"
            color="green-800"
          >
            <div className="flex items-center">
              <StaticImage
                src="../images/button-icon-line.png"
                alt="LINE"
                placeholder="none"
                width={20}
              />
              <Text fontSize="sm" color="white" classes="ml-1">
                まずはLINEで友だち追加
              </Text>
            </div>
          </ButtonFill>
        </div>
      </div>
    </div>
  )
}